import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes2";

import useTable from "../components/useTable";

import axios from "axios";
import moment from "moment";
import { formatMoneda } from "../util/varios";
import { Dimmer } from "../components/spinner";
import { DangerButton, SuccessButton } from "../ui/buttons/Button";
import { SearchInput } from "../ui/inputs/Input";
const CatalogoVerificacion = (props) => {
  let op = require("../modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const btnCancela = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const anioactu = JSON.parse(localStorage.getItem("anioactu"));
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [itemSelect, setItemSelect] = useState(-1);

  const headCells = [
    {
      id: "prefactura",
      label: "PREFACTURA",
      width: "60px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
    {
      id: "fechaverificacion",
      label: "FECHA",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
    {
      id: "liquidador",
      label: "VERIFICADOR",
      width: "300px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
    {
      id: "montototal",
      label: "MONTO",
      width: "180px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.prefactura.toLowerCase().includes(target.value.toLowerCase()) ||
              moment.utc(x.fechaverificacion)
                .format("DD/MM/YYYY")
                .includes(target.value.toLowerCase()) ||
              (x.liquidador !== null
                ? x.liquidador
                    .toLowerCase()
                    .trim()
                    .includes(target.value.toLowerCase())
                : "") ||
              formatMoneda(
                x.montototal.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              ).includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarVerificaciones = () => {
    setActivate(true);
    let endpoint =
      op.conexion +
      `/api/industria/selectverificaciones?anio=${parseInt(anioactu)}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setActivate(false);
          if (response.data.length > 0) {
            setRecords(response.data);
          } else {
            setRecords([]);
          }
        }
        setActivate(false);
      })
      .catch((error) => {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const blanquear = () => {
    setMostrar(false);
    setItemSelect("");
    setTitulo("");
    setMsg("");
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };

  const onChangeValidar = () => {
    if (itemSelect === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar un Item",
        icono: "informacion",
      });
    } else {
      seleccionarAgentes();
    }
  };

  const seleccionarAgentes = () => {
    blanquear();
    props.onHideAceptaCat(
      values.idve,
      values.idveficador,
      values.montot,
      values.liq,
      values.prefac,
      values.tipoing,
      values.ced,
      values.status,
      values.fecha
    );
  };

  const seleccionarFila = (index) => (event) => {
    event.preventDefault();
    setItemSelect(index);
    console.log(recordsAfterPagingAndSorting()[index].idtipoingreso);
    setValues({
      idve: recordsAfterPagingAndSorting()[index].idverificacion,
      idveficador: recordsAfterPagingAndSorting()[index].idverificador,
      montot: recordsAfterPagingAndSorting()[index].montototal,
      liq: recordsAfterPagingAndSorting()[index].liquidador,
      prefac: recordsAfterPagingAndSorting()[index].prefactura,
      tipoing: recordsAfterPagingAndSorting()[index].idtipoingreso,
      fecha: recordsAfterPagingAndSorting()[index].fechaverificacion,
      ced: recordsAfterPagingAndSorting()[index].cedula,
      status: recordsAfterPagingAndSorting()[index].status,
    });
  };
  const cancelar = () => {
    blanquear();
    props.onHideCancelaCatActi();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarVerificaciones();
        setItemSelect("");
      }}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="fw-bold m-0">Seleccionar Factura.</h3>
      </Modal.Header>
      <Modal.Body>
          <div className="col-4 m-0 p-0">
            <SearchInput
              onChange={handleSearch}
            />
          </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={item.idactividad}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td style={{ textAlign: "center" }}>{item.prefactura}</td>
                    <td style={{ textAlign: "center" }}>
                      {moment.utc(item.fechaverificacion).format("DD/MM/YYYY")}
                    </td>
                    <td style={{ textAlign: "left" }}>{item.liquidador}</td>
                    <td style={{ textAlign: "right" }}>
                      {item.montototal !== null
                        ? formatMoneda(
                            item.montototal.toString().replace(".", ","),
                            ",",
                            ".",
                            2
                          )
                        : "0,00"}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={values === "" ? true : false}
          onClick={onChangeValidar}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};

export default CatalogoVerificacion;
